/** @odoo-module **/
//import publicWidget from "@web/legacy/js/public/public_widget";
import { Component, mount, useSubEnv, useEffect, useChildSubEnv, useState, useEnv, useExternalListener } from "@odoo/owl";
//import { makeEnv } from "@web/env";
//import { getTemplate } from "@web/core/templates";

//import { registry } from "@web/core/registry";

import {WPCPortalLogin} from "@wpc_portal/components/login/login";
import {WPCPortalAccountStatus} from "@wpc_portal/components/account_status/account_status";
import {WPCPortalStudentPortal} from "@wpc_portal/pages/student_portal/student_portal";
import {WPCPortalTeacherPortal} from "@wpc_portal/pages/teacher_portal/teacher_portal";


export class WPCPortalRootPortalComponent extends Component {
    static template = "wpc_portal.wpc_portal_root_portal_component";
    static components = {
        WPCPortalLogin,
        WPCPortalAccountStatus,
        WPCPortalStudentPortal,
        WPCPortalTeacherPortal,
    }
    setup() {
        var self = this;
        self.state = useState({
            auth: {
                loaded: false,
                user_id: undefined,
                user_displayname: undefined,
                role: undefined,
            },
            page_args: {},
            currentMenuIndex: 0,
            currentMenu: null,
            menus: [],
            goNextMenu: self.goNextMenu.bind(this),
            goPreviousMenu: self.goPreviousMenu.bind(this),
//            goToMenu: self.goToMenu.bind(this),
        });

        useExternalListener(window, "hashchange", this.onWindowHashChanged);
        this.onWindowHashChanged();

        useEffect((role)=> {
            if (role === 'Student'){
                self.state.menus = [
                    {id: 'school_details', name: 'School Details', icon: 'bi bi-buildings'},
                    {id: 'personal_details', name: 'Personal Details', icon: 'bi bi-person-gear'},
                    // {id: 'address', name: 'Address', icon: 'bi bi-map'},
                    {id: 'medical_details', name: 'Medical Details', icon: 'bi bi-file-medical'},
                    {id: 'guardian_details', name: 'Parent/Carer Details', icon: 'bi bi-person-badge'},
                    {id: 'my_classes', name: 'My Classes', icon: 'bi bi-pencil'},
                    {id: 'my_placements', name: 'My Placements', icon: 'bi bi-list'},
                ];
                self.state.currentMenuIndex = 0;
            }
            else if (role === 'Teacher'){
                self.state.menus = [
                    {id: 'teacher', name: 'Teacher'},
                ];
                self.state.currentMenuIndex = 0;
            }
            else {
                self.state.menus = [];
            }
        }, ()=>[
            self.state.auth.role,
        ])

        useEffect(()=>{
            if (self.state.menus.length){
                self.state.currentMenu = self.state.menus[self.state.currentMenuIndex].id;
            }
            if (this.state.currentMenuIndex == 0){
                this.state.hasNextMenu = true;
                this.state.hasPreviousMenu = false;
            }
            else if (this.state.currentMenuIndex == this.state.menus.length - 1){
                this.state.hasNextMenu = false;
                this.state.hasPreviousMenu = true;
            }
            else{
                this.state.hasNextMenu = true;
                this.state.hasPreviousMenu = true;
            }
        }, ()=> [
            self.state.currentMenuIndex, self.state.menus,
        ]);

        useSubEnv({
            wpc_state: this.state,
            refresh_login_status: function() {
                $.ajax({url: '/auth/whoami', type: 'GET', dataType: 'json'})
                .then(data=>{
                console.log('WHOAMI', data);
                console.log('ASSIGN', self.env.wpc_state.auth, data.wpc_auth);
                    Object.assign(self.env.wpc_state.auth, data.wpc_auth);
                    if (!self.env.wpc_state.auth.role){
                        self.env.wpc_state.auth.step = 'cred';
                        self.env.wpc_state.auth.cred_type = 'login';
                    }
//                    self.env.wpc_state.auth = data.wpc_auth;
                    self.env.wpc_state.auth.loaded = true;
                });
            },
            doLogout: function(){
                $.ajax({url: '/auth/logout', dataType: 'json', type:'POST', data: {
                    // csrf_token: odoo.csrf_token,
                }})
                .then((result)=>{
                    self.env.refresh_login_status();
                }).fail((err)=>{
                    debugger;
                })
            }
        });
        self.env.refresh_login_status();
    }

    onWindowHashChanged(){
        const params = Object.fromEntries(new URLSearchParams(window.location.hash.replace('#?', '')));
        this.state.page_params = params;
        if (this.state.page_params.load_message){
            this.state.message = this.state.page_params.load_message;
        }
        // console.log('HASH CHANGED', params);
    }

    changeSelectedMenu(menu, menu_index) {
        this.state.currentMenuIndex = menu_index;
    }

//    goToMenu(menuId) {
//        if (this.state.menus.length){
//            this.state.currentMenuIndex = this.state.menus.findIndex((o)=>o.id === menuId);
//        }
//    }

    goPreviousMenu() {
        if (this.state.currentMenuIndex > 0 && this.state.menus.length > 1){
            this.state.currentMenuIndex--;
        }
    }
    goNextMenu() {
        if (this.state.currentMenuIndex < this.state.menus.length - 1 && this.state.menus.length > 0){
            this.state.currentMenuIndex++;
        }
    }
}

//registry.category("public_components").add("wpc_portal.WPCPortalRootComponent", WPCPortalRootComponent);
